export function OrbitalGridBackground() {
  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden="true">
      <svg
        width="600"
        height="600"
        viewBox="0 0 600 600"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2"
        style={{
          width: "min(240vmin, 2400px)",
          height: "min(240vmin, 2400px)",
          color: "hsl(var(--orbital-grid-stroke))",
          opacity: "var(--orbital-grid-opacity)",
          WebkitMaskImage: "radial-gradient(circle, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.95) 35%, rgba(0, 0, 0, 0.5) 65%, rgba(0, 0, 0, 0) 100%)",
          maskImage: "radial-gradient(circle, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.95) 35%, rgba(0, 0, 0, 0.5) 65%, rgba(0, 0, 0, 0) 100%)",
        }}
      >
        <path
          d="M300 300V12m0 288 74.54-278.187M300 300 444 50.585M300 300 503.647 96.353M300 300l249.415-144M300 300l278.187-74.54M300 300h288m-288 0 278.187 74.54M300 300l249.415 144M300 300l203.647 203.647M300 300l144 249.415M300 300l74.54 278.187M300 300v288m0-288-74.54 278.187M300 300 156 549.415M300 300 96.353 503.647M300 300 50.585 444M300 300 21.813 374.54M300 300H12m288 0L21.813 225.46M300 300 50.585 156M300 300 96.353 96.353M300 300 156 50.585M300 300 225.46 21.813M300 318c9.941 0 18-8.059 18-18s-8.059-18-18-18-18 8.059-18 18 8.059 18 18 18Z"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path d="M300 336c19.882 0 36-16.118 36-36s-16.118-36-36-36-36 16.118-36 36 16.118 36 36 36Z" stroke="currentColor" strokeWidth="0.2" />
        <path d="M300 372c39.765 0 72-32.235 72-72 0-39.764-32.235-72-72-72-39.764 0-72 32.236-72 72 0 39.765 32.236 72 72 72Z" stroke="currentColor" strokeWidth="0.2" />
        <path d="M300 408c59.647 0 108-48.353 108-108s-48.353-108-108-108-108 48.353-108 108 48.353 108 108 108Z" stroke="currentColor" strokeWidth="0.2" />
        <path d="M300 444c79.529 0 144-64.471 144-144s-64.471-144-144-144-144 64.471-144 144 64.471 144 144 144Z" stroke="currentColor" strokeWidth="0.2" />
        <path d="M300 480c99.411 0 180-80.589 180-180s-80.589-180-180-180-180 80.589-180 180 80.589 180 180 180Z" stroke="currentColor" strokeWidth="0.2" />
        <path d="M300 516c119.294 0 216-96.706 216-216S419.294 84 300 84 84 180.706 84 300s96.706 216 216 216Z" stroke="currentColor" strokeWidth="0.2" />
        <path d="M300 552c139.176 0 252-112.824 252-252S439.176 48 300 48 48 160.824 48 300s112.824 252 252 252Z" stroke="currentColor" strokeWidth="0.2" />
        <path d="M300 588c159.058 0 288-128.942 288-288S459.058 12 300 12 12 140.942 12 300s128.942 288 288 288Z" stroke="currentColor" strokeWidth="0.2" />
      </svg>
    </div>
  );
}
